import React, { useEffect, useRef } from 'react';
import { useVideoController } from '../controller/video/VideoControlContext';

const BG_COLOR = '#e2e2e2';
const LINE_COLOR = '#e45683';

const AudioStreamVisualizer = () => {
  const { localAudioTrack } = useVideoController();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const animationFrameRef = useRef<number>(0);

  useEffect(() => {
    if (localAudioTrack && canvasRef.current !== null) {
      const audioContext = new AudioContext();
      const source = audioContext.createMediaStreamSource(new MediaStream([localAudioTrack]));

      // High pass that shit
      const filter = audioContext.createBiquadFilter();
      filter.type = 'highpass';
      filter.frequency.value = 5000;
      filter.Q.value = 0;
      source.connect(filter);

      var compressor = audioContext.createDynamicsCompressor();
      compressor.threshold.setValueAtTime(-50, audioContext.currentTime);
      compressor.knee.setValueAtTime(40, audioContext.currentTime);
      compressor.ratio.setValueAtTime(12, audioContext.currentTime);
      compressor.attack.setValueAtTime(0, audioContext.currentTime);
      compressor.release.setValueAtTime(0.25, audioContext.currentTime);
      filter.connect(compressor);

      const analyser = audioContext.createAnalyser();
      analyser.minDecibels = -100;
      analyser.maxDecibels = -10;
      analyser.smoothingTimeConstant = 0.7;
      compressor.connect(analyser);

      const canvas = canvasRef.current;
      const width = canvas.width;
      const height = canvas.height;

      analyser.fftSize = 256;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      const canvasCtx: CanvasRenderingContext2D = canvas.getContext('2d')!;
      canvasCtx?.clearRect(0, 0, width, height);

      const draw = () => {
        animationFrameRef.current = requestAnimationFrame(draw);

        analyser.getByteFrequencyData(dataArray);

        canvasCtx.fillStyle = BG_COLOR;
        canvasCtx.fillRect(0, 0, width, height);

        canvasCtx.lineWidth = 1;
        canvasCtx.strokeStyle = LINE_COLOR;

        canvasCtx.beginPath();

        const barWidth = (width / bufferLength) * 2.5;
        let barHeight;
        let x = 0;

        for (let i = 0; i < bufferLength; i++) {
          barHeight = dataArray[i];

          canvasCtx.fillStyle = LINE_COLOR;
          canvasCtx.fillRect(x, (height - barHeight) / 2, barWidth - 2, barHeight);

          x += barWidth;
        }
      };

      draw();

      return () => {
        audioContext.close();
        cancelAnimationFrame(animationFrameRef.current);
      };
    }
  }, [localAudioTrack]);

  return <canvas style={{ width: '100%' }} ref={canvasRef}></canvas>;
};

export default AudioStreamVisualizer;
